import { define } from 'wicked-elements'
import bus from '../bus'

define('[data-component~="gallery-signal"]', {
  init () {
    const signals = this.element.parentElement.querySelectorAll(
      ':scope > [data-component~="gallery-signal"]'
    )

    this.index = [...signals].indexOf(this.element)
  },
  connected () {
    this.element.onmouseenter = () => {
      bus.emit('gallery', this.index)
    }
    this.element.onmouseleave = () => {
      bus.emit('gallery', false)
    }

    bus.on('gallery', i => {
      if (i === this.index) {
        this.element.classList.add('active')
      } else {
        this.element.classList.remove('active')
      }
    })
  }
})
